/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Tags_WeaponInputs */

const en_control_tags_weapon = /** @type {(inputs: Control_Tags_WeaponInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weapon support`)
};

const zh_control_tags_weapon = /** @type {(inputs: Control_Tags_WeaponInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`武器联动`)
};

/**
* | output |
* | --- |
* | "Weapon support" |
*
* @param {Control_Tags_WeaponInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_tags_weapon = /** @type {((inputs?: Control_Tags_WeaponInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Tags_WeaponInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_tags_weapon(inputs)
	return zh_control_tags_weapon(inputs)
});
export { control_tags_weapon as "control.tags.weapon" }